import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {GameObject, Transform2dComponent} from '@specials/gcs-engine';

import {PixiViewRendererComponent} from '@/gcs/PixiViewRendererComponent';

import {EmittersContainerViewComponent} from './EmittersContainerViewComponent';

export class EmittersContainer extends GameObject {
  constructor(
    private readonly transformComponent: Transform2dComponent,
    private readonly container: EmittersContainerViewComponent,
    private readonly rendererComponent: PixiViewRendererComponent,
  ) {
    super();

    this.addComponent(this.transformComponent, this.container, this.rendererComponent);
  }
}

injected(
  EmittersContainer,
  DI_TOKENS.transform2dComponent,
  DI_TOKENS.clickerGameEmittersContainerViewComponent,
  DI_TOKENS.pixiViewRendererComponent,
);
